var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg094Upload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V5.41L7.71 8.71C7.31788 9.10212 6.68212 9.10212 6.29 8.71C5.89788 8.31788 5.89788 7.68212 6.29 7.29L11.29 2.29C11.4778 2.10069 11.7334 1.9942 12 1.9942C12.2666 1.9942 12.5222 2.10069 12.71 2.29L17.71 7.29C17.8993 7.47777 18.0058 7.73336 18.0058 8C18.0058 8.26664 17.8993 8.52223 17.71 8.71C17.5222 8.89931 17.2666 9.0058 17 9.0058C16.7334 9.0058 16.4778 8.89931 16.29 8.71L13 5.41V16ZM2 20C2 19.4477 2.44772 19 3 19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg094Upload);
export default __webpack_public_path__ + "static/media/094-upload.b405293edfc58598957292b83330985f.svg";
export { ForwardRef as ReactComponent };